import { centsToDollarString } from './constants';

export const COMMITMENT_TYPE_OPTIONS = [
  { value: 'original_scope', label: 'Original Scope' },
  { value: 'extra_work', label: 'Extra Work' },
];

export const commitmentTypeLabel = (v) =>
  (COMMITMENT_TYPE_OPTIONS.find((o) => o.value === v) || {}).label || v;

export const COMMITMENT_STATUS_OPTIONS = [
  { value: 'draft', label: 'Draft' },
  { value: 'approved', label: 'Approved' },
  { value: 'completed', label: 'Completed' },
  { value: 'cancelled', label: 'Cancelled' },
];

export const commitmentStatusLabel = (v) =>
  (COMMITMENT_STATUS_OPTIONS.find((o) => o.value === v) || {}).label || v;

export const COMMITMENT_STATUS_STYLES = {
  draft: 'bg-gray-800 text-gray-300 border-gray-700',
  approved: 'bg-green-900/40 text-green-400 border-green-800',
  completed: 'bg-blue-900/40 text-blue-400 border-blue-800',
  cancelled: 'bg-red-900/40 text-red-400 border-red-800',
};

export const COMMITMENT_SORT_OPTIONS = [
  { value: 'date_newest', label: 'Newest Commitment Date' },
  { value: 'date_oldest', label: 'Oldest Commitment Date' },
  { value: 'amount_high', label: 'Highest Amount' },
  { value: 'amount_low', label: 'Lowest Amount' },
  { value: 'recently_updated', label: 'Recently Updated' },
  { value: 'subcontractor_az', label: 'Subcontractor A–Z' },
];

export const SUB_PAY_METHOD_OPTIONS = [
  { value: 'cash', label: 'Cash' },
  { value: 'check', label: 'Check' },
  { value: 'ach', label: 'ACH / Bank Transfer' },
  { value: 'card', label: 'Credit / Debit Card' },
  { value: 'other', label: 'Other' },
];

export const subPayMethodLabel = (v) =>
  (SUB_PAY_METHOD_OPTIONS.find((o) => o.value === v) || {}).label || v;

export const balanceLabel = (cents) => {
  if (cents > 0) return 'Amount still owed';
  if (cents < 0) return 'Advance / Overpayment';
  return 'Paid / balanced';
};

export const balanceDisplay = (cents) => centsToDollarString(cents);
